import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import { ArrowLeft2 } from "iconsax-react";
import { Button } from "@/shared/ui";
import { ACCOUNTING_WAREHOUSE_PAGE_ROUTE } from "@/shared/utils";

export default function RequestsHeader() {
  const { t } = useTranslation("WarehouseRequestsPage");
  const navigate = useNavigate();

  return (
    <div className="flex items-center justify-between pb-4 border-b surface-base-stroke mb-5 pt-1 pr-1">
      <h1 className="text-display-xs content-base-primary">{t("title")}</h1>
      <Button variant="secondary" size="lg" onClick={() => navigate(ACCOUNTING_WAREHOUSE_PAGE_ROUTE)}>
        <ArrowLeft2 size={16} color="currentColor" />
        {t("nav.backToWarehouse")}
      </Button>
    </div>
  );
}

